// stripeConfig.js

// Mode: live

import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = "pk_live_51SNOQOCLao3bw0G098l8Lt4Mox88hjPRGFn0eq7v0jxGZOr5jdQv0scD0dJpXe9ilOkFuQm66R4WwBMHXZ9izvJx00UqpYEg5n"; 

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

export const paymentProcessor = "stripe";  //stripe|dodopayments|paddle

export const applicationName = "Trimzly";

export const paddleClientSideToken = "";

export const paddleEnvironmentMode = "";

export const PLANS = {
  "trialPeriodDurationInDays": 7,
  "order": [
    "lite",
    "standard",
    "advanced",
    "enterprise"
  ],
  "annualSavingPercentage": 18,
  "monthly": {
    "lite": {
      "price": 9.95
    },
    "standard": {
      "price": 19.95
    },
    "advanced": {
      "price": 49.95
    },
    "enterprise": {
      "price": 99.95
    }
  },
  "yearly": {
    "lite": {
      "price": 8.16
    },
    "standard": {
      "price": 16.36
    },
    "advanced": {
      "price": 40.96
    },
    "enterprise": {
      "price": 81.96
    }
  },
  "planAdditionaInfo": {
    "lite": {
      "title": "Lite",
      "description": "Ideal for single bakeries to track orders, recipes, and daily checklists efficiently.",
      "maxUserAccounts": 1,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "standard": {
      "title": "Standard",
      "description": "Suited for bustling bakeries handling varied orders, team management, and unique bakes.",
      "popular": true,
      "maxUserAccounts": 10,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "advanced": {
      "title": "Advanced",
      "description": "Designed for large bakeries with advanced tools for bulk orders, scheduling, and analytics.",
      "maxUserAccounts": 25,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    },
    "enterprise": {
      "title": "Enterprise",
      "description": "Tailored for bakery franchises to manage multiple sites, inventory, and workflows seamlessly.",
      "maxUserAccounts": 50,
      "features": [
        "Full Access",
        "Metrics & Insights",
        "Customer Support"
      ]
    }
  }
};